exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scroll-elements {\n  width: 300px;\n  height: 200px;\n  overflow: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/widgets/FontConfigurator/FontLibraryDropdown.scss
// module id = 1384
// module chunks = 0